"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCategoryName = void 0;
var translation_1 = require("@caddigital/sok-reducers/lib/utils/translation");
var getCategoryName = function (group) {
    if (group.type === 'WorksiteDiaryUserGroup') {
        return ((0, translation_1.getLocalization)('userfront/project/teamMembers/worksitediaryUserGroup') +
            ' - ' +
            group.name);
    }
    //meterType has the following two string values: "MVRMETER", "TRMETER"
    if (group.type === 'TRMVRUserGroup' &&
        (group.meterType === 'MVRMETER' || group.meterType === 'TRMETER')) {
        return ((0, translation_1.getLocalization)("userfront/project/teamMembers/trmvrMeterUserGroup/".concat(group.meterType)) +
            ' - ' +
            group.name);
    }
    return group.name;
};
exports.getCategoryName = getCategoryName;
